class DSCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Add-to-Cart via Liquid-Ajax-Cart (z.B. <ajax-cart-product-form>, Cart-Drawer-Upsells)
    document.addEventListener("liquid-ajax-cart:request-end", (event) => {
      const { requestState, cart } = event.detail;

      if (requestState.requestType == "add" && requestState.responseData.ok) {
        this.open();
      }

      this.updateCartEmptyState(cart);
    });

    // Add-to-Cart via Theme-<product-form> (PDP "In den Warenkorb"-Button):
    // Das Theme fügt per eigenem AJAX-Call hinzu und emittiert danach "cart:change".
    // Wir synchronisieren den Liquid-Ajax-Cart-State (damit Sections + Mutations laufen)
    // und öffnen den Drawer, sobald das Update durch ist.
    document.documentElement.addEventListener("cart:change", (event) => {
      if (event.detail && event.detail.baseEvent === "variant:add") {
        if (window.liquidAjaxCart) {
          window.liquidAjaxCart.update();
          document.addEventListener("liquid-ajax-cart:request-end", () => {
            this.open();
          }, { once: true });
        } else {
          this.open();
        }
      }
    });

    this.addEventListener('click', (event) => {
      if (event.target.matches('#CartDrawer-Overlay')) {
        this.close();
      }
    });
    this.setHeaderCartIconAccessibility();
  }

  updateCartEmptyState(cart) {
    const isEmpty = !cart || cart.item_count === 0;
    const emptyWrapper = this.querySelector('.ds-drawer__inner-empty');
    const header = this.querySelector('.ds-drawer__header');
    const cartContent = this.querySelector('.ds-cart-content');
    const cartDrawerItems = this.querySelector('cart-drawer-items');

    if (isEmpty) {
      this.classList.add('is-empty');
      // Show empty state elements
      if (emptyWrapper) emptyWrapper.style.display = 'block';
      if (header) header.style.display = 'flex';
      // Hide cart content wrapper
      if (cartContent) cartContent.style.display = 'none';
      if (cartDrawerItems) cartDrawerItems.classList.add('is-empty');
    } else {
      this.classList.remove('is-empty');
      // Hide empty state
      if (emptyWrapper) emptyWrapper.style.display = 'none';
      // Show cart content wrapper
      if (header) header.style.display = 'flex';
      if (cartContent) cartContent.style.display = 'flex';
      if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
    }
  }

  connectedCallback() {
    // Set initial cart state on mount
    if (window.liquidAjaxCart && window.liquidAjaxCart.cart) {
      this.updateCartEmptyState(window.liquidAjaxCart.cart);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#ds-cart-icon-bubble');
    console.log("cartLink", cartLink);
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.ds-drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.ds-drawer__inner') || this.querySelector('.ds-drawer__close');
        // trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    // removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {

      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'ds-cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}




class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('ds-cart-drawer', DSCartDrawer);
customElements.define('cart-drawer-items', CartDrawerItems);